import apiClient from '@services/apiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

interface IIBANValidationResponse {
	iban_structure_valid: boolean;
	iban_checksum_valid: boolean;
	bic: string | null;
	requires_vop_check: boolean;
}

export const useIBANValidation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (iban: string) =>
			queryClient.fetchQuery({
				queryKey: ['iban', iban],
				queryFn: async () => {
					try {
						const response = await apiClient.post<IIBANValidationResponse>(
							'/utilities/iban/validate',
							{ includeDetails: false, iban },
						);

						return response.data;
					} catch (error) {
						if ((error as AxiosError).status === 422) {
							return {
								iban_structure_valid: false,
								requires_vop_check: false,
								iban_checksum_valid: false,
							};
						}

						throw error;
					}
				},
				staleTime: Infinity,
			}),
	});
};
